import { Stack, Typography, useTheme } from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";

interface IViewStructureProperty {
    label: string;
    value: any[];
    /*{
        label: string;
        value: string;
        error: boolean
    }*/
}

/**
 * Section to view structured property of Disambiguation details
 */
const ViewStructuredProperty = (props: IViewStructureProperty) => {

    const theme = useTheme();

    const [record, setRecords] = useState<any>([]);

    useEffect(() => {
        let blocks = [];

        if (!!props && !! props.value && props?.value?.length !== 0) {
            for (let i = 0; i < props.value.length; i++) {
                blocks.push(
                    <Stack direction="row" justifyContent="space-between" columnGap={5} px={1} ml={4}
                           style={!!props?.value[i].error ? {background: theme.palette.neutral.light, borderRadius: 3} : {}}
                           key={props.value[i].label}>
                        <Typography>
                            {props.value[i].label}
                        </Typography>
                        <Typography fontWeight={550}
                                    key={i}
                                    sx={{
                                        color:
                                            !!props?.value[i].error
                                                ? theme.palette.error.main
                                                : '',
                                    }}>
                            {!!props.value[i].value ? props.value[i].value : '-'}
                        </Typography>
                    </Stack>
                );
            }
            setRecords(blocks);
        }
    }, [props.value]);


    return (
        <>
            <Typography px={1}>
                {props?.label}
            </Typography>
                {record}
        </>
    );

}

export default ViewStructuredProperty;
